import {HeadingNode, QuoteNode} from "@lexical/rich-text"
import {ListItemNode, ListNode} from "@lexical/list"
import {CodeNode} from "@lexical/code"
import {AutoLinkNode, LinkNode} from "@lexical/link"
import {ImageNode} from "../image/node/node"
import {MentionNode} from "../mentions/node/node"
import {EmojiNode} from "../emoji/node/emoji-node"

export const TableCellNodes = [
    HeadingNode,
    ListNode,
    ListItemNode,
    QuoteNode,
    CodeNode,
    // CodeHighlightNode,
    AutoLinkNode,
    LinkNode,
    ImageNode,
    MentionNode,
    EmojiNode,
]